import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { IamAuthService, MsalGuardFromService } from '@cemex-core/msal-services-v1';
import { AuthGuard } from '@cemex/cmx-client-layout';
import { AuthService } from '../../cmx-client-layout/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthFactoryGuard implements CanActivate, CanActivateChild {
  private authGuard: AuthGuard = inject(AuthGuard);
  private msalGuard: MsalGuardFromService = inject(MsalGuardFromService);
  private iamService: IamAuthService = inject(IamAuthService);
  private authService: AuthService = inject(AuthService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    const isAuthIamStarted = this.iamService.isAuthIamStarted();

    if (isAuthIamStarted) {
      this.authService.loadAuthState();
    }

    return isAuthIamStarted ? this.msalGuard.canActivate(route, state) : this.authGuard.canActivate();
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    const isAuthIamStarted = this.iamService.isAuthIamStarted();

    if (isAuthIamStarted) {
      this.authService.loadAuthState();
    }

    return isAuthIamStarted ? this.msalGuard.canActivate(childRoute, state) : this.authGuard.canActivateChild();
  }
}
